import {
  TRENDING_DATA_LOADING,
  TRENDING_DATA_SUCCESS,
  TRENDING_DATA_ERROR,
  TRENDING_ACCESS_SUCCESS,
  TRENDING_AFFILIATED_LOADING,
  TRENDING_AFFILIATED_SUCCESS,
  TRENDING_AFFILIATED_ERROR,
} from 'store/actions/trendingActions';

// Keeps a bounded number of fetched quarter-files in memory. Evicted entries
// cost almost nothing to reload: the objects are immutable per quarter and
// CloudFront serves them with a 30-day Cache-Control, so a refetch after
// eviction is answered by the browser's HTTP cache without touching the
// network.
//
// ~1 entity's chart = quarters-in-range files; 300 comfortably holds several
// recently viewed entities across data types at a few MB of JSON.
const MAX_ENTRIES = 300;

const initialState = {
  entries: {}, // key -> { loading, loaded, data, error, loadedAt }
  order: [], // insertion order of loaded keys, for eviction
  accessExpiresAt: null, // CloudFront signed-cookie expiry (from /v2/data/access)
  // clientId -> { loading, loaded, npiSet: Set, error } — the client's
  // affiliated provider NPIs, for O(1) affiliation lookups on shared-* rows.
  // Small (one set of short strings per client), so not part of the LRU.
  affiliatedByClient: {},
};

export const trending = (state = initialState, action = null) => {
  switch (action && action.type) {
    case TRENDING_DATA_LOADING:
      return {
        ...state,
        entries: {
          ...state.entries,
          [action.key]: { loading: true, loaded: false, data: null },
        },
      };

    case TRENDING_DATA_SUCCESS: {
      const entries = {
        ...state.entries,
        [action.key]: {
          loading: false,
          loaded: true,
          data: action.data,
          loadedAt: Date.now(),
        },
      };
      const order = [...state.order.filter((k) => k !== action.key), action.key];
      while (order.length > MAX_ENTRIES) {
        const evict = order.shift();
        delete entries[evict];
      }
      return { ...state, entries, order };
    }

    case TRENDING_DATA_ERROR: {
      const entries = {
        ...state.entries,
        [action.key]: { loading: false, loaded: false, error: action.error },
      };
      return { ...state, entries };
    }

    case TRENDING_ACCESS_SUCCESS:
      return { ...state, accessExpiresAt: action.expiresAt };

    case TRENDING_AFFILIATED_LOADING:
      return {
        ...state,
        affiliatedByClient: {
          ...state.affiliatedByClient,
          [action.clientId]: { loading: true, loaded: false, npiSet: null },
        },
      };

    case TRENDING_AFFILIATED_SUCCESS:
      return {
        ...state,
        affiliatedByClient: {
          ...state.affiliatedByClient,
          [action.clientId]: {
            loading: false,
            loaded: true,
            npiSet: new Set(action.npis),
          },
        },
      };

    case TRENDING_AFFILIATED_ERROR:
      return {
        ...state,
        affiliatedByClient: {
          ...state.affiliatedByClient,
          [action.clientId]: { loading: false, loaded: false, error: action.error },
        },
      };

    default:
      return state;
  }
};
